@if (initialized()) {
  <nw-dom-content>
    <div class="button-container">
      <nw-language-select></nw-language-select>
      <div class="others-option d-flex align-items-center mx-2">
        <div class="option-item">
          <span
            data-nw-modal-target="#loginModal"
            data-nw-modal-options='{"backdrop":true, "keyboard":true}'
            #toggle
          >
            <i class="flaticon-user"></i> {{'PatientLogin' | localize}}
          </span>
        </div>
      </div>
    </div>
    <div id="loginModal" class="modal" role="dialog" aria-hidden="true" #LoginModal>
      <div class="modal-dialog">
          <div class="modal-content">
              <button
                type="button"
                class="close"
                #dismissButton
                data-nw-modal-dismiss
                aria-label="Close"
                (click)="loginComponent.reset()"
              >X</button>
              <div class="modal-header">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                      <button
                        class="nav-link active"
                        id="login-tab"
                        type="button"
                        role="tab"
                        aria-selected="true"
                      >{{ 'Login' | localize }}/{{ 'Register' | localize}}</button>
                  </li>
              </ul>
              </div>
              <div class="modal-body">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="login" role="tabpanel">
                    <nw-login
                      #loginComponent
                      (loginWithBankId)="loginWithBankId(bankIdSigningModal); dismissButton.click()"
                      (dismissLoginModal)="dismissButton.click()"
                    ></nw-login>
                  </div>
                </div>
              </div>
          </div>
      </div>
    </div>
    <nw-bankid-signing-modal #bankIdSigningModal (modalSave)="bankIdSignIn($event)" (modalClosed)="toggle.click()"></nw-bankid-signing-modal>
  </nw-dom-content>
}
